<template>
  <v-card elevation="5" outlined shaped>


    <v-dialog v-model="avisoModal" max-width="650">
      <v-card elevation="5" outlined shaped>
        <v-list-item>
          <v-list-item-title class="text-center">
            <h4>INFORMACIÓN IMPORTANTE</h4>
          </v-list-item-title>
        </v-list-item>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <div>


                  <v-alert dense color="#21618C" style="color: #ffffff">
                    <h4>
                      * UNA VEZ REALIZADA LA INSCRIPCIÓN O TOMA DE MATERIAS &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; NO PODRA QUITAR O ELIMINAR LAS
                      INSCRIPCIONES.

                      <br> <br>
                      * SI NECESITA QUITAR O MODIFICAR SU INSCRIPCIÓN BUSQUE A SU &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                      &nbsp; &nbsp;&nbsp; CORDINADOR DE CARRERA.
                    </h4>
                  </v-alert>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="carreraModal" max-width="600" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>CARRERA</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersCarrera" :items="datosCarrera" :items-per-page="5" class="elevation-1"
                  id="tableId" hide-default-footer disable-pagination
                  @click:row="($event, { item }) => seleccionarCarrera(item)">

                  <template #[`item.actions`]="{ item }">
                    <v-icon color="#0091EA" title="SELECCIONAR CARRERA" small class="mr-2"
                      @click="seleccionarCarrera(item)">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeCarrera" style="float: right"
                  title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="documentosModal" max-width="600" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>DOCUMENTOS PENDIENTES</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersDocumentos" :items="datosDocumentos" :items-per-page="5"
                  class="elevation-1" id="tableId">

                  <template #[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="seleccionarDocumento(item)">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark small color="red darken-1" @click="closeDocumento" style="float: right"
                  title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="gestionModal" max-width="400" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GESTION</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersGestion" :items="datosGestion" :items-per-page="5" class="elevation-1"
                  id="tableId" hide-default-footer disable-pagination
                  @click:row="($event, { item }) => seleccionarGestion(item)">

                  <template #[`item.actions`]="{ item }">
                    <v-icon color="#0091EA" title="SELECCIONAR GESTION" small class="mr-2"
                      @click="seleccionarGestion(item)">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeGestion" style="float: right"
                  title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="turnoModal" max-width="400" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>TURNO</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col cols="12">
                <v-data-table :headers="headersTurno" :items="datosTurno" :items-per-page="5" class="elevation-1"
                  id="tableId" hide-default-footer disable-pagination
                  @click:row="($event, { item }) => seleccionarTurno(item)">

                  <template #[`item.actions`]="{ item }">
                    <v-icon color="#0091EA" title="SELECIONAR TURNO" small class="mr-2" @click="seleccionarTurno(item)">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeTurno" style="float: right"
                  title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detalleModal" max-width="900" class="text-center">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GRUPOS DISPONIBLES</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table :headers="headersGrupoInscripcion" :items="datosGruposInscripcion" :items-per-page="10"
                  class="elevation-1" id="tableId" hide-default-footer disable-pagination
                  @click:row="($event, { item }) => seleccionarGrupo(item)">
                  <template #[`item.tpgru`]="{ item }">
                    <v-chip :color="getColorGrupos(item.tpgru)" light center-active>
                      {{ item.tpgru }}
                    </v-chip>
                  </template>


                  <template #[`item.actions`]="{ item }">
                    <v-icon color="#0091EA" small class="mr-2" @click="seleccionarGrupo(item)"
                      title="SELECCIONAR GRUPO">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark small color="red darken-1" @click="closeDetalleInscripcion"
                  style="float: right" title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="gruposPracticosModal" max-width="900" class="text-center">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GRUPOS PRÁCTICOS DISPONIBLES</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>




              <v-col cols="12">
                <v-data-table :headers="headersGrupoInscripcionPracticos" :items="datosGruposInscripcionPracticos"
                  :items-per-page="10" class="elevation-1" id="tableId" hide-default-footer disable-pagination
                  @click:row="($event, { item }) => seleccionarGrupoPractico(item)">
                  <template #[`item.tpgru`]="{ item }">
                    <v-chip :color="getColorGrupos(item.tpgru)" light center-active>
                      {{ item.tpgru }}
                    </v-chip>
                  </template>

                  <template #[`item.actions`]="{ item }">
                    <v-icon color="#0091EA" small class="mr-2" @click="seleccionarGrupoPractico(item)"
                      title="SELECCIONAR GRUPO PRÁCTICO">
                      mdi-check-circle
                    </v-icon>
                  </template>
                </v-data-table>


              </v-col>
              <!--v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn class="mx-2" fab dark small color="red darken-1" @click="closeGruposPractica"
                  style="float: right" title="SALIR">
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col-->


            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>





    <div>
      <v-alert dense color="#EE680B" style="color: #ffffff">
        <h5>INSCRIPCIÓN</h5>
      </v-alert>
    </div>
    <div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row>

            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="1">
              <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showCarrera()" style="float: right"
                title="BUSCAR CARRERA">
                <v-icon dark> mdi-gesture-double-tap </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="carrera" label="CARRERA" disabled required></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showGestion()" style="float: right"
                title="BUSCAR GESTION">
                <v-icon dark> mdi-gesture-double-tap </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field v-model="gestion" label="GESTION" disabled required></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showTurno()" style="float: right"
                title="BUSCAR TURNO">
                <v-icon dark> mdi-gesture-double-tap </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field v-model="turno" label="TURNO" disabled required></v-text-field>
            </v-col>

            <v-col cols="12" md="1">
              <!--  <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showTurno()" style="float: right"
                title="BUSCAR GRUPO">
                <v-icon dark> mdi-gesture-double-tap </v-icon>
              </v-btn> -->
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field v-model="grupoSeleccionado" label="GRUPO" disabled required></v-text-field>
            </v-col>







          </v-row>
        </v-container>
      </v-form>
    </div>




    <v-card elevation="5" outlined shaped>
      <v-card-text>
        <v-row>
          <v-list-item v-if="banddeuda == 'NOTIENEDEUDA' && bandbac == 'NOTIENEBAC'">
            <v-list-item-title class="text-center">
              <h5>OFERTA DE MATERIAS</h5>
            </v-list-item-title>
          </v-list-item>
          <v-col cols="12" v-if="banddeuda == 'NOTIENEDEUDA'&& bandbac == 'NOTIENEBAC'">

            <!--v-col cols="12">
                      <v-card-title>
                        <v-text-field v-model="searchFormacionAcad" append-icon="mdi-magnify" label="BUSCAR DETALLE"
                          single-line hide-details></v-text-field>
                      </v-card-title>
                    </v-col-->
            <v-data-table :headers="headersOfertaMaterias" :items="datosOfertaMaterias" :items-per-page="10"
              class="elevation-1" id="tableId" :footer-props="{ itemsPerPageText: 'DATOS POR PAGINA' }"
              @click:row="($event, { item }) => showDetalleInscripcion(item)">




              <template #[`item.actions`]="{ item }">
                <!--v-icon small class="mr-2" @click="seleccionarDocumento(item)">
                                                            mdi-check-bold
                                                          </v-icon-->
                <v-icon small class="mr-2" color="#0091EA" @click="showDetalleInscripcion(item)" title="VER GRUPOS">
                  mdi-gesture-tap
                </v-icon>
                <!--v-icon small class="mr-2" @click="seleccionarDelFormAcad(item)" title="ELIMINAR INFORMACION">
                          mdi-delete-forever
                        </v-icon-->
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" md="12" v-if="banddeuda == 'TIENEDEUDA'&& bandbac == 'NOTIENEBAC'">
            <v-alert color="#FFAB00" dark dense icon="mdi-alert-outline" style="color: black" prominent>
              ¡¡¡ TIENE DEUDAS PENDIENTES !!! :()
            </v-alert>
          </v-col>

          <v-list-item v-if="banddeuda == 'NOTIENEDEUDA'&& bandbac == 'NOTIENEBAC'">
            <v-list-item-title class="text-center">
              <h5>MATERIAS PREINSCRITAS</h5>
            </v-list-item-title>
          </v-list-item>
          <v-col cols="12" v-if="banddeuda == 'NOTIENEDEUDA'&& bandbac == 'NOTIENEBAC'">

            <v-data-table :headers="headersGrupoPreInscripcion" :items="datosGruposPreInscripcion" :items-per-page="10"
              class="elevation-1" id="tableId" hide-default-footer disable-pagination>
              <template #[`item.tpgru`]="{ item }">
                <v-chip :color="getColorGrupos(item.tpgru)" dark center-active>
                  {{ item.tpgru }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <!--v-icon v-if="item.practic == 'ACTIVO'" small class="mr-2" @click="showGruposPractica(item)"
                      title="AÑADIR MATERIA PRÁCTICA">
                      mdi-pencil-plus-outline
                    </v-icon-->
                <v-icon v-if="item.tipoinscr == 'WEBEST'" color="red" small class="mr-2"
                  @click="seleccionarQuitarMateria(item)" title="QUITAR MATERIA">
                  mdi-delete-forever
                </v-icon>
              </template>
            </v-data-table>

          </v-col>
          <v-col cols="12" v-if="banddeuda == 'TIENEDEUDA'&& bandbac == 'NOTIENEBAC'">
            <v-data-table :headers="headersDeuda" :items="datosDeuda" hide-default-footer disable-pagination
              class="elevation-1" id="tableId">
              <template #[`item.actions`]="{ item }">
                <!--v-icon small class="mr-2" @click="seleccionarDocumento(item)">
                                                                  mdi-check-bold
                                                                </v-icon-->
                <v-chip :color="getColor1(item.deuda)" dark>
                  {{ item.deuda }}
                </v-chip>


              </template>
            </v-data-table>


          </v-col>

          <v-col cols="12" md="12" v-if="bandbac == 'TIENEBACVENCIDO'">
            <v-alert color="#FFAB00" dark dense icon="mdi-alert-outline" style="color: black" prominent>
              ¡¡¡ TIENE PLAN ECONOMICO BAC VENCIDO !!! :()
            </v-alert>
          </v-col>
          <v-col cols="12" v-if="bandbac == 'TIENEBACVENCIDO'">
            <v-data-table :headers="headersBAC" :items="datosvigenciaBac" hide-default-footer disable-pagination
              class="elevation-1" id="tableId">
              <template #[`item.actions`]="{ item }">
                <v-chip :color="getColor1(item.deuda)" dark>
                  {{ item.deuda }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>



        </v-row>
      </v-card-text>
    </v-card>





    <div class="text-center">
      <v-snackbar v-model="snackbarOK" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbar }}</strong>


        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarOK = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">

      <v-snackbar v-model="snackbarError" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbar }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>

    <div class="text-center">

      <v-snackbar v-model="snackbarError1" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarHorario }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError1 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>
    <div class="text-center">

      <v-snackbar v-model="snackbarError2" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarGrupoLleno }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError2 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarErrorSinHora" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarSinHora }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarErrorSinHora = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>

      <v-snackbar v-model="snackbarError3" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarNivel }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError3 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarError4" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarQuitarMateriaNivel }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError4 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarErrorMaxMat" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarCantidadMaximaMaterias }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarErrorMaxMat = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarError5" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarDocumentos }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError5 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarError6" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
        <strong>{{ mensajeSnackbarFechaInscripcion }}</strong>

        <template v-slot:action="{ attrs }">
          <v-icon right v-bind="attrs" @click="snackbarError6 = false">
            mdi-close
          </v-icon>
        </template>
      </v-snackbar>
    </div>

  </v-card>


</template>
<script>
import axios from "axios"
import VueHtml2pdf from 'vue-html2pdf'
export default {
  data() {
    return {
      recursadapr: "N",
      banderaRecursado: 0,
      datosRecursado: [],
      recursada: 'N',
      hoy: "",
      fechaEntrega: "",
      tipoInscripcion: "WEBADM",
      mat: "",
      pat: "",
      id_estudiante: "",
      unicodigo: "",
      num_documento: "",
      paterno: "",
      materno: "",
      nombres: "",
      nombreCompleto: "",
      datosCarrera: [],
      idPlanestudio: "",
      idCarrera: "",
      carrera: "",
      gestion: "",
      idGestion: "",
      datosOfertaMaterias: [],
      idMateria: "",
      detalleModal: 0,
      datosCantidadEstGrupo: [],
      datosGruposInscripcion: [],
      idTurno: "",
      datosTurno: [],
      turno: "",
      idGrupoDocente: "",
      idTipoModalidad: 1,
      modalidad: "",
      paralelo: "",
      paraleloPrac: "",
      capacidad: "",
      tipoGrupo: "",
      idNivel: "",
      idUsuario: "",
      idPlanEconomico: "",
      yaInscrito: false,
      cantidadMaximaMaterias: 0,
      //maxMateriasPreinscritas: 0,
      cantidadActualMaterias: "",
      datosGruposPreInscripcion: [],
      idNota: "",
      minimoNivel: "",
      datosOfertaMateriasNivel: [],
      idGrupoAux: "",
      snackbarErrorMaxMat: 0,


      //tipo: "PRACTICO",
      gruposPracticosModal: 0,

      horarioModal: 0,
      datosHorario: [],
      idFranjaHoraria: "",
      idDia: "",
      cantAct: "",
      datosCantidadEspacio: [],
      datosHorariosGrupo: [],
      datosFranjaHoraria: [],
      //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
      tienePractico: "FALSE",
      paraleloTeorico: "",
      choqueHorario: 0,
      idGrupoPadre: "",
      esCompartido: "",
      kardexModal: 0,
      datosDocumentos: [],
      choquecant: 0,
      search: "",
      inpNum: "",
      id_docente: "",
      tipodocente: "",
      searchDocente: "",
      selectGenero: "",
      datosGenero: ["FEMENINO", "MASCULINO"],
      auxmat: "",
      auxpat: "",
      uniest: "",
      datosOfertaCorregido: [],
      datosCantMateriasEst: [],
      datosEstudiante: [],
      datosGestion: [],
      datosKardex: [],
      datosGruposInscripcionPracticos: [],
      est: "",
      elModal: 0,
      carreraModal: 0,
      gestionModal: 0,
      turnoModal: 0,
      horarioModal1: 0,
      documentosModal: 0,
      datosNivelesPreinscritos: [],
      nivelMaximoPreInscrito: "",

      itencant: 0,
      doble: 0,
      itemcantidadModal: 0,
      deleteDialog: 0,
      oldNum: "",
      iditemdet: "",
      iditemdet1: "",
      totaldet: "",
      idtrans: "",
      busest: "",
      idcategoriaest: "",
      categoriaest: "",
      tiponacional: "",
      paisest: "",

      snackbarOK: false,
      mensajeSnackbar: "",
      mensajeSnackbarGrupoLleno: "GRUPO LLENO COMUNIQUESE CON SU COORD.",
      mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
      mensajeSnackbarHorario: 'CHOQUE DE HORARIO COMUNIQUESE CON SU COORD.',
      mensajeSnackbarCantidadMaximaMaterias: 'CANTIDAD MAXIMA DE MATERIAS TOMADAS COMUNIQUESE CON SU COORD.',
      mensajeSnackbarQuitarMateriaNivel: "PRIMERO QUITE MATERIAS DE NIVEL SUPERIOR",
      mensajeSnackbarDocumentos: "REGULARICE SU DOCUMENTACIÓN",
      mensajeSnackbarFechaInscripcion: "FUERA DE FECHA DE INSCRIPCIONES COMUNIQUESE CON SU COORD.",
      snackbarError: false,
      snackbarError1: false,
      snackbarError2: false,
      snackbarError3: false,
      snackbarError4: false,
      snackbarError6: false,
      mensajeError: "",
      datosHorariosGrupoPrac: [],

      timeout: 2000,

      alert: { show: false, message: "" },
      alertdocumento: { show: false, message: "" },


      headersTurno: [

        { text: "TURNO", value: "turno", sortable: true, class: 'my-header-style' },
        /* { text: "OPCIONES", value: "actions", sortable: false }, */
      ],
      headersHorario: [
        { text: "HORA", value: "hr", sortable: true },
        { text: "LUNES", value: "docaumat", sortable: true },
        { text: "MARTES", value: "docaumat", sortable: true },
        { text: "MIERCOLES", value: "docaumat", sortable: true },
        { text: "JUEVES", value: "docaumat", sortable: true },
        { text: "VIERNES", value: "docaumat", sortable: true },
        { text: "SABADO", value: "docaumat", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersDocumentos: [
        { text: "DOCUMENTO", value: "documento", sortable: true },
        { text: "FECHA", value: "fpl", sortable: true },
        { text: "ESTADO", value: "estado", sortable: true },
        // { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersFranjaHoraria: [
        { text: "HORA", value: "hr", sortable: true },
        { text: "LUNES", value: "lu", sortable: true },
        { text: "MARTES", value: "ma", sortable: true },
        { text: "MIERCOLES", value: "mi", sortable: true },
        { text: "JUEVES", value: "ju", sortable: true },
        { text: "VIERNES", value: "vi", sortable: true },
        { text: "SABADO", value: "sa", sortable: true },
        { text: "DOMINGO", value: "do", sortable: true },

      ],
      headersCarrera: [

        { text: "CARRERA", value: "carre", sortable: true, class: 'my-header-style' },
        /* { text: "OPCIONES", value: "actions", sortable: false }, */
      ],
      headersCantidadEstGrupo: [

        { text: "GRUPO", value: "idgru", sortable: true },
        { text: "PATERNO", value: "pat", sortable: true },
        { text: "MATERNO", value: "mat", sortable: true },
        { text: "NOMBRE", value: "nomb", sortable: true },
        { text: "ESTUDIANTES INSCRITOS", value: "cant", sortable: true },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersGrupoInscripcion: [
        { text: "GRUPO", value: "gru", sortable: true, class: 'my-header-style' },
        { text: "DOCENTE", value: "doce", sortable: true, class: 'my-header-style' },
        { text: "NIVEL", value: "idnv", sortable: true, class: 'my-header-style' },
        { text: "CUPO", value: "cup", sortable: true, class: 'my-header-style' },
        { text: "MODALIDAD", value: "modalidad", sortable: true, class: 'my-header-style' },
        { text: "TURNO", value: "tu", sortable: true, class: 'my-header-style' },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true, class: 'my-header-style' },
        //{ text: "ESTADO", value: "est", sortable: true },
        /*  { text: "OPCIONES", value: "actions", sortable: false }, */
      ],
      idGrupoDocentePrac: "",
      headersGrupoInscripcionPracticos: [
        { text: "GRUPO", value: "gru", sortable: true, class: 'my-header-style' },
        { text: "DOCENTE", value: "doce", sortable: true, class: 'my-header-style' },
        { text: "NIVEL", value: "idnv", sortable: true, class: 'my-header-style' },
        { text: "CUPO", value: "cup", sortable: true, class: 'my-header-style' },
        { text: "MODALIDAD", value: "modalidad", sortable: true, class: 'my-header-style' },
        { text: "TURNO", value: "tu", sortable: true, class: 'my-header-style' },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true, class: 'my-header-style' },
        //{ text: "ESTADO", value: "est", sortable: true },
        //{ text: "OPCIONES", value: "actions", sortable: false },
      ],
      datosPlanEconomico: [],
      headersGrupoPreInscripcion: [
        { text: "PARALELO", value: "gru", sortable: true, class: 'my-header-style' },
        { text: "MATERIA", value: "mate", sortable: true, class: 'my-header-style' },
        { text: "DOCENTE", value: "doce", sortable: true, class: 'my-header-style' },
        { text: "NIVEL", value: "idnv", sortable: true, class: 'my-header-style' },
        //{ text: "CUPO", value: "cup", sortable: true },
        { text: "MODALIDAD", value: "modalidad", sortable: true, class: 'my-header-style' },
        { text: "TURNO", value: "tu", sortable: true, class: 'my-header-style' },
        { text: "TIPO DE GRUPO", value: "tpgru", sortable: true, class: 'my-header-style' },
        //{ text: "ESTADO", value: "est", sortable: true },
        //{ text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersOfertaMaterias: [


        { text: "NIVEL", value: "idni", sortable: true, class: 'my-header-style' },
        //{ text: "IDMATERIA", value: "idmat", sortable: true },
        { text: "CODIGO MATERIA", value: "codmat", sortable: true, class: 'my-header-style' },
        { text: "MATERIA", value: "mat", sortable: true, class: 'my-header-style' },
        //{ text: "CANT MAX", value: "cantmax", sortable: true },
        //{ text: "ESTADO", value: "est", sortable: true },
        /* { text: "OPCIONES", value: "actions", sortable: false ,  class: 'my-header-style' }, */
      ],
      headersGestion: [

        { text: "GESTION", value: "nom", sortable: true, class: 'my-header-style' },
        /* { text: "OPCIONES", value: "actions", sortable: false }, */
      ],
      headersEstudiante: [
        { text: "UNICODIGO", value: "unicod", sortable: true },

        { text: "PATERNO", value: "pat", sortable: false },
        { text: "MATERNO", value: "mat", sortable: false },
        { text: "NOMBRES", value: "nom", sortable: false },
        { text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersKardex: [

        { text: "GESTION", value: "gest", sortable: true },
        { text: "MATERIA", value: "mate", sortable: true },
        { text: "1° P", value: "p1", sortable: true },
        { text: "2° P", value: "p2", sortable: false },
        { text: "3° P", value: "p3", sortable: true },
        { text: "EXM FINAL", value: "exfin", sortable: false },
        { text: "2° INST", value: "seginst", sortable: true },
        { text: "MESA", value: "mesa", sortable: false },
        { text: "GRACIA", value: "graci", sortable: true },
        { text: "NOTA FINAL", value: "notafin", sortable: true },
        { text: "ESTADO", value: "estado", sortable: false },
        { text: "OBSERVACIONES", value: "observac", sortable: true },

      ],
      snackbarErrorSinHora: false,
      avisoModal: 0,
      mensajeSnackbarSinHora: "GRUPO SIN HORARIOS",
      user: {},
      usuario: "",
      id_sede: "",
      nomus: "",
      patus: "",
      matus: "",
      id_documento: "",
      datosTipoDocumento: "",

      id_tipo_documento: "",
      tipo_doc_nom: "",
      iddocseg2: "",
      documento2: "",
      nivelMinimo: "",

      select: "",
      selectAño: "",
      selectCiudad: "",
      selectPais: "",
      tituloObtenido: "",
      institucion: "",
      areaEstudios: null,
      añoObtencion: "",
      cargaHoraria: null,
      datosPais: [],
      datosCiudad: [],
      tpFormacion: "",
      datosFormacionAcademica: [],
      selectPais1: "",
      act: 0,
      idForm: "",
      botonAct: 0,
      datosDeuda: [],
      banddeuda: "",
      headersDeuda: [
        { text: "GESTION", value: "gest", sortable: false, class: 'my-header-style' },
        { text: "CONCEPTO", value: "item", sortable: false, class: 'my-header-style' },
        { text: "MONTO A COBRAR(Bs)", value: "deuda", sortable: false, class: 'my-header-style' },
        { text: "DESCUENTO(Bs)", value: "montodes", sortable: false, class: 'my-header-style' },
        //{ text: "TOTAL(Bs)", value: "totales", sortable: false },
        //{ text: "OPCIONES", value: "actions", sortable: false },
      ],
      headersBAC: [
        { text: "PLAN ECONOMICO", value: "plannom", sortable: false, class: 'my-header-style' },
        { text: "GESTION INICIO", value: "gini", sortable: false, class: 'my-header-style' },
        { text: "GESTION FIN", value: "gfin", sortable: false, class: 'my-header-style' },
        { text: "OBS", value: "obsvg", sortable: false, class: 'my-header-style' },
        //{ text: "TOTAL(Bs)", value: "totales", sortable: false },
        //{ text: "OPCIONES", value: "actions", sortable: false },
      ],


      flag: 1,
      grupoSeleccionado: "",

      datosMinNivelOfertaMat: [],
      minNivelOfertaMat: 0,
      datosNumeroOfertaMat: [],
      numeroOfertaMat: 0,
      datosMinNivelGruposPreInscritos: [],
      minNivelGruposPreinscritos: 0,
      datosvigenciaBac: [],
      tipoGestion: 0,
      ordGestion: 0,
      id_GestIniBac: 0,
      id_GestFinBac: 0,
      bandbac:"",




    };
  },
  created: function () {
    this.user = JSON.parse(sessionStorage.getItem("session"));
    this.usuario = this.user.personal;
    this.id_sede = this.user.id_sede;
    this.sede = this.user.sede;
    this.nomus = this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
    this.unicodigo = this.user.unico;
    this.avisoModal = true;




  },
  computed: {},
  components: {
    VueHtml2pdf,

  },

  methods: {
    encontrarMinimoNivel() {
      for (let i = 0; i < this.datosOfertaMaterias.length; i++) {
        this.datosOfertaMateriasNivel.push(this.datosOfertaMaterias[i].idni);
      }
      this.nivelMinimo = Math.min.apply(null, this.datosOfertaMateriasNivel);

      if (this.idNivel <= this.nivelMinimo) {
        this.listarDocumento(this.unicodigo);
      } else {
        //console.log("seleccione nivel mas bajo");
        this.snackbarError3 = true;
      }


      //console.log(this.nivelMinimo);
      // console.log(this.datosOfertaMateriasNivel);
      this.datosOfertaMateriasNivel = [];
    },

    encontrarNivelAltoGrupoPreinscritos() {
      for (let i = 0; i < this.datosGruposPreInscripcion.length; i++) {
        this.datosNivelesPreinscritos.push(this.datosGruposPreInscripcion[i].idnv);
      }
      this.nivelMaximoPreInscrito = Math.max.apply(null, this.datosNivelesPreinscritos);

      if (this.idNivel == this.nivelMaximoPreInscrito) {
        this.verificarQuitarMateria();
      } else {
        //console.log("seleccione nivel mas bajo");
        this.snackbarError4 = true;
      }


      //console.log(this.nivelMinimo);
      // console.log(this.datosOfertaMateriasNivel);
      this.datosNivelesPreinscritos = [];
    },
    verificarDocumentos() {


      this.hoy = new Date();

      for (let i = 0; i < this.datosDocumentos.length; i++) {
        this.fechaEntrega = new Date(this.datosDocumentos[i].fpl);


        if (this.datosDocumentos[i].estado == 'PENDIENTE') {
          if (this.hoy.getTime() <= this.fechaEntrega.getTime()) {

            this.verificarTipoGrupo();
          } else {
            this.showDocumento();
            this.snackbarError5 = true;

          }

        } else {
          this.verificarTipoGrupo();
        }
      }
    },
    limpiarApell() {
      this.pat = "";
      this.mat = "";
      this.uniest = "";
    },
    aumentarEspacios() {
      if (this.pat != "" && this.mat == "") {
        this.mat = " ";
      } else {
        if (this.pat == "" && this.mat != "") {
          this.pat = " ";
        } else {

        }
      }
    },
    extraerCantMateriasTomadasEst() {

      this.cantidadActualMaterias = this.datosCantMateriasEst[0].cantmat;
      //console.log(this.cantidadActualMaterias);   

    },


    getColor(insc) {
      if (insc == 'LIBRE') return 'green'
      else return '#868582'
    },
    getColorKardex(insc) {
      if (insc == 'APROBADO') return 'green'
      else return 'red'
    },
    getColorGrupos(insc) {
      if (insc == 'TEORICO') return 'light-blue accent-2'
      else return 'orange accent-2'
    },
    async listarTurno() {
      let me = this;
      await axios
        .get("/estudiante/listarTurnoIns/" + this.idGestion + "," + this.idPlanestudio + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosTurno = [];

          } else {

            me.datosTurno = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarPlanEconomico() {
      let me = this;
      await axios
        .get("/estudiante/listarPlanEconomicoEstudiante/" + this.unicodigo + "," + this.idPlanestudio + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosPlanEconomico = [];

          } else {

            me.datosPlanEconomico = response.data.resultado;
            me.idPlanEconomico = me.datosPlanEconomico[0].idplan;
          }
        })
        .catch(function (error) {

        });
    },


    async listarDocumento(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/buscadepen/" + this.unicodigo)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosDocumentos = [];
            me.verificarTipoGrupo();

          } else {


            me.datosDocumentos = response.data.resultado;
            me.verificarDocumentos();
          }
        })
        .catch(function (error) {

        });
    },
    async listarDocumento1(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/buscadepen/" + this.unicodigo)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosDocumentos = [];
            me.verificarTipoGrupo();

          } else {


            me.datosDocumentos = response.data.resultado;
            me.verificarDocumentos();
          }
        })
        .catch(function (error) {

        });
    },



    async listarFranjaHoraria(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/listarFranjaHorariaEstCompartido/" + this.unicodigo + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosFranjaHoraria = [];

          } else {

            me.datosFranjaHoraria = response.data.resultado;
            me.datosFranjaHoraria.forEach(function (dato) {

              let dd = 'LIBRE';
              dato.lu = dd;
              dato.ma = dd;
              dato.mi = dd;
              dato.ju = dd;
              dato.vi = dd;
              dato.sa = dd;
              dato.do = dd;
            });
            for (let i = 0; i < me.datosFranjaHoraria.length; i++) {
              for (let j = 0; j < me.datosHorario.length; j++) {
                if (me.datosFranjaHoraria[i].idfh == me.datosHorario[j].idfranja) {

                  switch (me.datosHorario[j].dias) {
                    case 'LUNES':
                      me.datosFranjaHoraria[i].lu = me.datosHorario[j].docaumat;
                      break;
                    case 'MARTES':
                      me.datosFranjaHoraria[i].ma = me.datosHorario[j].docaumat;
                      break;
                    case 'MIERCOLES':
                      me.datosFranjaHoraria[i].mi = me.datosHorario[j].docaumat;
                      break;
                    case 'JUEVES':
                      me.datosFranjaHoraria[i].ju = me.datosHorario[j].docaumat;
                      break;
                    case 'VIERNES':
                      me.datosFranjaHoraria[i].vi = me.datosHorario[j].docaumat;
                      break;
                    case 'SABADO':
                      me.datosFranjaHoraria[i].sa = me.datosHorario[j].docaumat;
                      break;
                    case 'DOMINGO':
                      me.datosFranjaHoraria[i].do = me.datosHorario[j].docaumat;
                      break;
                    default:
                  }
                }
              }
            }


          }//else
        })
        .catch(function (error) {

        });
    },
    async listarHorario(unicodigo, idGestion, idPlanestudio) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioEstudiante/" + this.unicodigo + "," + this.idGestion + "," + this.idPlanestudio + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorario = [];

          } else {

            me.datosHorario = response.data.resultado;

            me.listarFranjaHoraria(me.unicodigo);
          }
        })
        .catch(function (error) {

        });
    },


    async listarGruposInscripcion(idPlanestudio, idMateria, id_sede, idGestion, idTurno, idTipoModalidad) {
      let me = this;
      await axios
        .get("/estudiante/gruposInscripcion/" + this.idPlanestudio + "," + this.idMateria + "," + this.id_sede + "," + this.idGestion + "," + this.idTurno + "," + this.idTipoModalidad)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGruposInscripcion = [];

          } else {

            me.datosGruposInscripcion = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarGruposInscripcionSelect(idPlanestudio, idMateria, id_sede, idGestion, idTurno, idTipoModalidad) {
      let me = this;
      await axios
        .get("/estudiante/gruposInscripcionselect/" + this.idPlanestudio + "," + this.idMateria + "," + this.id_sede + "," + this.idGestion + "," + this.idTurno + "," + this.idTipoModalidad + "," + this.grupoSeleccionado)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGruposInscripcion = [];

          } else {

            me.datosGruposInscripcion = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarGruposInscripcionPractica(
      idPlanestudio,
      idMateria,
      id_sede,
      idGestion,
      idTurno,
      idTipoModalidad
    ) {
      let me = this;
      await axios
        .get(
          "/estudiante/gruposInscripcionPractico/" +
          this.idPlanestudio +
          "," +
          this.idMateria +
          "," +
          this.id_sede +
          "," +
          this.idGestion +
          "," +
          this.idTurno +
          "," +
          this.idTipoModalidad +
          "," +
          this.paraleloTeorico
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGruposInscripcionPracticos = [];
          } else {
            me.datosGruposInscripcionPracticos = response.data.resultado;
          }
        })
        .catch(function (error) { });
    },
    async listarGruposPreInscripcion(idPlanestudio, id_sede, idGestion, idTurno, idTipoModalidad, unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/gruposPreinscritos/" + this.idPlanestudio + "," + this.id_sede + "," + this.idGestion + "," + this.idTurno + "," + this.idTipoModalidad + "," + this.unicodigo)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGruposPreInscripcion = [];
            //console.log("NO TIENE GRUPOS")
            me.verificarMinNivel()
          } else {

            me.datosGruposPreInscripcion = response.data.resultado;
            //console.log("TIENE GRUPOS")
            me.grupoSeleccionado = me.datosGruposPreInscripcion[0].gru;
            me.verificarMinNivel()

          }
        })
        .catch(function (error) {

        });
    },
    async listarMinNivelGruposPreInscritos() {
      let me = this;
      await axios
        .get("/estudiante/listarminnivelgrupospreinscritos/" + this.idPlanestudio + "," + this.id_sede + "," + this.idGestion + "," + this.idTurno + "," + this.idTipoModalidad + "," + this.unicodigo)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosMinNivelGruposPreInscritos = [];
          } else {

            me.datosMinNivelGruposPreInscritos = response.data.resultado;
            me.minNivelOfertaMat = me.datosMinNivelGruposPreInscritos[0].min_id_nivel_preins;
            console.log("min_nivel preinscr " + me.minNivelOfertaMat)
            me.listarNumeroOfertaMaterias();


          }
        })
        .catch(function (error) {

        });
    },
    async listarvigeciabacest(unicodigo, id_sede) {

      let me = this;
      await axios
        .get("/pagos/listarvigebacest/" + this.unicodigo + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosvigenciaBac = [];
            console.log("no tiene bac")
             me.bandbac = "NOTIENEBAC";
          } else {

            me.datosvigenciaBac = response.data.resultado;
            console.log("si tiene bac")
            me.id_GestIniBac = me.datosvigenciaBac[0].id_ord_ini;
            me.id_GestFinBac = me.datosvigenciaBac[0].id_ord_fin;
            console.log("ini " + me.id_GestIniBac);
            console.log("fin " + me.id_GestFinBac);
            me.verificarVencimientoBac();

          }
        })
        .catch(function (error) {

        });

    },
    verificarVencimientoBac() {
      if (this.ordGestion > this.id_GestFinBac && this.tipoGestion === 'R') {
        console.log("FUERA DEL RANGO");
         this.bandbac = "TIENEBACVENCIDO";

      }
      else {
        console.log("DENTRO DEL RANGO")
         this.bandbac = "NOTIENEBAC";
      }

    },
    async listarCarrera(unicodigo) {
      let me = this;
      await axios
        .get("/estudiante/listarcarreraestu/" + this.unicodigo + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCarrera = [];

          } else {

            me.datosCarrera = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarGestion() {
      let me = this;
      await axios
        .get("/estudiante/buscagestionactualinscr/")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGestion = [];

          } else {

            me.datosGestion = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarKardex() {
      let me = this;
      await axios
        .get("/estudiante/kardex/" + this.unicodigo + "," + this.idCarrera + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosKardex = [];

          } else {

            me.datosKardex = response.data.resultado;
          }
        })
        .catch(function (error) {

        });
    },
    async listarCantidadMateriasPreinsEstu(unicodigo, idGestion) {

      let me = this;
      await axios
        .get("/estudiante/cantmateriasinscest/" + this.unicodigo + "," + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCantMateriasEst = [];

          } else {

            me.datosCantMateriasEst = response.data.resultado;



            me.extraerCantMateriasTomadasEst();
          }
        })
        .catch(function (error) {

        });
    },
    async listarOfertaMaterias(unicodigo, idPlanestudio, idGestion) {
      let me = this;
      await axios
        .get("/estudiante/ofertamaterias/" + this.unicodigo + "," + this.idPlanestudio + "," + this.idGestion + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosOfertaMaterias = [];

          } else {
            me.datosOfertaMaterias = response.data.resultado;
          }

        })
        .catch(function (error) {

        });
    },
    /* async listarOfertaMateriaspruebas(unicodigo, idPlanestudio, idGestion) {
      let me = this;
      await axios
        .get("/estudiante/ofertamateriasprueba/" + this.unicodigo + "," + this.idPlanestudio + "," + this.idGestion + "," + this.id_sede+ "," + this.numeroOfertaMat)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosOfertaMaterias = [];

          } else {
            me.datosOfertaMaterias = response.data.resultado;
            //me.listarOfertaMateriasMinNivel();
          }

        })
        .catch(function (error) {

        });
    }, */

    async listarOfertaMateriasMinNivel() {
      let me = this;
      await axios
        .get(
          "/estudiante/minimonivelofertamaterias/" +
          this.unicodigo +
          "," +
          this.idPlanestudio +
          "," +
          this.idGestion +
          "," +
          this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosMinNivelOfertaMat = [];
          } else {
            me.datosMinNivelOfertaMat = response.data.resultado;
            me.minNivelOfertaMat = me.datosMinNivelOfertaMat[0].minimo_id_nivel;
            console.log("minimo nivel oferta " + me.minNivelOfertaMat);
            me.listarNumeroOfertaMaterias();
          }
        })
        .catch(function (error) { });
    },

    async listarNumeroOfertaMaterias() {
      let me = this;
      await axios
        .get(
          "/estudiante/numeroofertamaterias/" +
          this.idPlanestudio +
          "," +
          this.id_sede +
          "," +
          this.minNivelOfertaMat
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosMinNivelOfertaMat = [];
          } else {
            me.datosNumeroOfertaMat = response.data.resultado;
            me.cantidadMaximaMaterias = me.datosNumeroOfertaMat[0].total_numero;
            //me.cantidadMaximaMaterias = 4;
            //console.log("CANT numero de oferta " + me.cantidadMaximaMaterias);
            //me.listarOfertaMateriaspruebas();
          }
        })
        .catch(function (error) { });
    },

    async listarHorarioGrupoPractico(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioGrupo/" + this.idGrupoDocentePrac + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorariosGrupoPrac = [];
            me.snackbarErrorSinHora = true;

          } else {

            me.datosHorariosGrupoPrac = response.data.resultado;
            //console.log("HORARIO grupos prac")
            //console.log(me.datosHorariosGrupoPrac);

            me.compararHorariosPractico();
          }
        })
        .catch(function (error) {

        });
    },
    async listarHorarioGrupoPrivado(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioGrupo/" + this.idGrupoDocente + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorariosGrupo = [];
            me.snackbarErrorSinHora = true;

          } else {

            me.datosHorariosGrupo = response.data.resultado;
            //console.log("HORARIO grupos teori")
            //console.log(me.datosHorariosGrupo);

            me.compararHorarios();
          }
        })
        .catch(function (error) {

        });
    },
    async listarHorarioGrupoCompartido(idGrupoPadre) {
      let me = this;
      await axios
        .get("/estudiante/listarHorarioGrupo/" + this.idGrupoPadre + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosHorariosGrupo = [];
            me.snackbarErrorSinHora = true;

          } else {

            me.datosHorariosGrupo = response.data.resultado;

            me.compararHorarios();
          }
        })
        .catch(function (error) {

        });
    },

    imprimirKardex() {

      this.$refs.html2Pdf.generatePdf();


    },



    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    change(event) {
      let val = event.target.value.trim();
      // Solo puede ser un entero positivo o vacío, el regular se puede modificar según las necesidades
      //item = e.target.value.replace(/[^\d]/g,'')
      if (/^[1-9]\d*$|^$/.test(val)) {
        this.oldNum = val;
      } else {
        event.target.value = this.oldNum;
      }
    },

    buscarEstudiante() {
      //this.aumentarEspacios();
      if (this.uniest != "") {
        this.listarEstudianteUnicod(this.uniest, this.id_sede);
      } else {
        this.listarEstudiante(this.pat, this.mat, this.id_sede);
      }
    },

    async listarEstudiante(pat, mat, id_sede) {
      if (this.pat == "") {
        this.auxpat = "XXX"
      } else {
        this.auxpat = this.pat
      }
      if (this.mat == "") {
        this.auxmat = "XXX"
      } else {
        this.auxmat = this.mat
      }
      let me = this;
      await axios
        .get("/estudiante/buscarestapell/" + this.auxpat + "," + this.auxmat + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosEstudiante = [];
            me.limpiarApell();
            me.snackbarOK = true;
            me.mensajeSnackbar = response.data.message;

          } else {

            me.datosEstudiante = response.data.resultado;
            me.limpiarApell();
          }
        })
        .catch(function (error) {

        });

    },
    async listarEstudianteUnicod(uniest, id_sede) {

      let me = this;
      await axios
        .get("/estudiante/buscaestunicodigoinsc/" + this.uniest + "," + this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosEstudiante = [];
            me.limpiarApell();
            me.snackbarOK = true;
            me.mensajeSnackbar = response.data.message;

          } else {

            me.datosEstudiante = response.data.resultado;
            me.limpiarApell();
          }
        })
        .catch(function (error) {

        });

    },
    seleccionarEstudiante(item) {

      this.id_estudiante = item.idest;
      this.unicodigo = item.unicod;
      this.paterno = item.pat;
      this.materno = item.mat;
      this.nombres = item.nom;
      this.nombreCompleto = item.nom + " " + item.pat + " " + item.mat;
      this.elModal = false;
      this.limpiar();
      //this.establecerMateriaRecursada(this.unicodigo);

    },
    seleccionarGrupo(item) {
      this.datosHorariosGrupo = [];
      //this.datosHorario=[];
      if (this.cantidadMaximaMaterias > this.cantidadActualMaterias) {
        console.log("puede tomar " + this.cantidadMaximaMaterias + " tiene " + this.cantidadActualMaterias)
        this.idGrupoDocente = item.idgr;
        console.log("id_grupo " + this.idGrupoDocente);
        this.idTipoModalidad = item.idmod;
        this.modalidad = item.modalidad;
        //this.paralelo = item.gru;
        this.paraleloTeorico = item.gru;
        this.capacidad = item.cup;
        this.tipoGrupo = item.tpgru;

        this.idNivel = item.idnv;
        this.cantAct = item.cantact;
        this.idGrupoPadre = item.idgppadre;
        this.esCompartido = item.tipogr; //
        this.idMateria = item.idmat;
        this.detalleModal = false;
        //console.log("tipo gruo" +this.esCompartido);
        console.log("idgrupo Teorico" + this.idGrupoDocente);
        //console.log("paraleloTeorico" +this.paraleloTeorico);

        //this.encontrarMinimoNivel();

        this.listarFechaInscripcion();
      } else {
        this.snackbarErrorMaxMat = true;
        this.mensajeSnackbarCantidadMaximaMaterias;
        this.detalleModal = false;
      }
    },
    async listarFechaInscripcion(idGestion) {
      let me = this;
      await axios
        .get("/estudiante/listarFechasInscripciones/" + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosFechaInscripcion = [];

            me.verificarFechaInscripcion();
          } else {
            me.datosFechaInscripcion = response.data.resultado;
            me.verificarFechaInscripcion();
          }
        })
        .catch(function (error) { });
    },
    verificarFechaInscripcion() {
      this.hoy1 = new Date();
      // this.hoy1=this.hoy1.setMinutes(this.hoy1.getMinutes() + this.hoy1.getTimezoneOffset());

      for (let i = 0; i < this.datosFechaInscripcion.length; i++) {
        this.fechaInscripcionIni = new Date(
          this.datosFechaInscripcion[i].fecini
        );
        // this.fechaInscripcionIni=this.fechaInscripcionIni.setMinutes(this.fechaInscripcionIni.getMinutes() + this.fechaInscripcionIni.getTimezoneOffset());
        this.fechaInscripcionFin = new Date(
          this.datosFechaInscripcion[i].fecfin
        );

        if (
          this.datosFechaInscripcion[i].ideve == 1 &&
          this.datosFechaInscripcion[i].estad == "ACTIVO"
        ) {
          if (
            this.hoy1.getTime() >= this.fechaInscripcionIni.getTime() &&
            this.fechaInscripcionFin.getTime() >= this.hoy1.getTime()
          ) {
            // BLOQUEAR PARA VERANOS 
            // this.encontrarMinimoNivel();
            this.encontrarMinimoNivel();
          } else {
            this.snackbarError6 = true;
            //console.log("no esta en la fecha de inscripcion")
          }
        } else {
          //this.verificarTipoGrupo();
          this.snackbarError6 = true;
          //console.log("no esta en la fecha de inscripcion")
        }
      }
    },

    verificarTipoGrupo() {
      if (this.esCompartido === 'COMPARTIDO') {
        this.verificarGrupoCompartido();

      } else {
        this.verificarGrupoPrivado();
      }
    },
    verificarGrupoCompartido() {

      this.listarHorarioGrupoCompartido(this.idGrupoPadre);
    },
    verificarGrupoPrivado() {

      this.listarHorarioGrupoPrivado(this.idGrupoDocente);
    },
    verificado() {
      this.verificarEspacio();

      //this.verificarExisteMateriaPractica();

    },
    verificarEspacio() {
      this.listarCantActualInscr(this.idGrupoDocente);
    },

    async listarCantActualInscr(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/verificarEspacio/" + this.idGrupoDocente)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCantidadEspacio = [];
          } else {
            me.datosCantidadEspacio = response.data.resultado;

            me.espacioVerificado();
          }
        })
        .catch(function (error) { });
    },

    /* espacioVerificado() {
      if (this.capacidad > this.datosCantidadEspacio[0].cnt && this.capacidad != 0) {
        this.inscribir();
        //this.datosCantidadEspacio = [];
      }
      else {
        this.snackbarError2 = true;
        //this.datosCantidadEspacio = [];
      }
    }, */
    espacioVerificado() {
      //console.log("CUP T " + this.capacidad);
      //console.log("CAN T " + this.datosCantidadEspacio[0].cnt);
      if (
        this.capacidad > this.datosCantidadEspacio[0].cnt &&
        this.capacidad != 0
      ) {
        //console.log("inscribe")
        this.inscribir();
        //this.datosCantidadEspacio = [];
      } else {
        //console.log("cupo lleno")
        this.snackbarError2 = true;
        //this.datosCantidadEspacio = [];
      }
    },


    /* inscribir() {
      if (this.yaInscrito == false) {
        this.verificarInscripcion();
        this.verificarPreinscipcionNota();
        this.yaInscrito = true;
      } else {
        this.verificarPreinscipcionNota();
      }

    }, */
    inscribir() {
      if (this.yaInscrito == false) {
        // ANULAR ESTE METODO PARA INSCRBIR
        //this.verificarInscripcion();
        //*******************************
        this.verificarPreinscipcionNota();
        this.yaInscrito = true;
      } else {
        this.verificarPreinscipcionNota();
      }
    },

    compararHorarios() {
      //console.log("entro");

      this.choquecant = 0;
      this.choqueHorario = 0;

      for (let i = 0; i < this.datosHorariosGrupo.length; i++) {
        for (let j = 0; j < this.datosHorario.length; j++) {
          if (this.datosHorario[j].iddi == this.datosHorariosGrupo[i].iddi &&
            this.datosHorario[j].idfranja == this.datosHorariosGrupo[i].idfh
          ) {
            this.choqueHorario = 1;
            this.choquecant = this.choquecant + this.choqueHorario;
          }
          else {
            this.choqueHorario = 0;
            this.choquecant = this.choquecant + this.choqueHorario;
          }
        }
      }
      //for
      if (this.choquecant == 0) {
        this.verificado();

      } else {
        ;
        this.snackbarError1 = true;
        this.mensajeSnackbarHorario;
      }


    },
    /* compararHorarios() {
     
      // this.choquecant = 0;
      // this.choqueHorario = 0;

      // for (let i = 0; i < this.datosHorariosGrupo.length; i++) {
      //   for (let j = 0; j < this.datosHorario.length; j++) {
      //     if (
      //       this.datosHorario[j].iddi == this.datosHorariosGrupo[i].iddi &&
      //       this.datosHorario[j].idfranja == this.datosHorariosGrupo[i].idfh
      //     ) {
      //       this.choqueHorario = 1;
      //       this.choquecant = this.choquecant + this.choqueHorario;
      //     } else {
      //       this.choqueHorario = 0;
      //       this.choquecant = this.choquecant + this.choqueHorario;
      //     }
      //   }
      // }
      // //for

      // if (this.choquecant == 0) {
         this.verificado();
      // } else {
      //   this.snackbarError1 = true;
      //   //this.mensajeSnackbarHorario ;
      // }
    }, */

    seleccionarGrupoPractico(item) {
      this.idGrupoDocentePrac = item.idgr;
      console.log("idgrupo PRACTICO" + this.idGrupoDocentePrac)
      //this.idGrupoDocente = item.idgr;
      this.idTipoModalidad = item.idmod;
      this.modalidad = item.modalidad;
      this.paralelo = item.gru;
      //this.capacidad = item.capac;
      this.capacidad = item.cup;
      this.tipoGrupo = item.tpgrup;
      this.idNivel = item.idniv;
      this.gruposPracticosModal = false;
      //this.verificarEspacioPractico();
      this.listarHorarioGrupoPractico();


      //this.compararHorariosPractico();
      //this.verificarPreinscipcionNotaPractica();
    },
    compararHorariosPractico() {
      //console.log("entro");

      this.choquecant = 0;
      this.choqueHorario = 0;

      for (let i = 0; i < this.datosHorariosGrupoPrac.length; i++) {
        for (let j = 0; j < this.datosHorario.length; j++) {
          if (this.datosHorario[j].iddi == this.datosHorariosGrupoPrac[i].iddi &&
            this.datosHorario[j].idfranja == this.datosHorariosGrupoPrac[i].idfh
          ) {
            this.choqueHorario = 1;
            this.choquecant = this.choquecant + this.choqueHorario;
          }
          else {
            this.choqueHorario = 0;
            this.choquecant = this.choquecant + this.choqueHorario;
          }
        }
      }
      //for
      if (this.choquecant == 0) {
        this.verificarEspacioPractico();

      } else {
        ;
        this.snackbarError1 = true;
        this.mensajeSnackbarHorario;
      }


    },
    verificarEspacioPractico() {
      this.listarCantActualInscrPractico(this.idGrupoDocentePrac);
    },
    async listarCantActualInscrPractico(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/verificarEspacio/" + this.idGrupoDocentePrac)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCantidadEspacio = [];
          } else {
            me.datosCantidadEspacio = response.data.resultado;

            me.espacioVerificadoPractico();
          }
        })
        .catch(function (error) { });
    },
    espacioVerificadoPractico() {
      //console.log("CUP P " + this.capacidad);
      //console.log("CAN P " + this.datosCantidadEspacio[0].cnt);
      if (
        this.capacidad > this.datosCantidadEspacio[0].cnt &&
        this.capacidad != 0
      ) {
        //this.inscribir();
        //this.datosCantidadEspacio = [];

        this.verificarPreinscipcionNotaPractica();


      } else {
        this.snackbarError2 = true;
        //this.datosCantidadEspacio = [];
      }
    },

    seleccionarCarrera(item) {
      this.carrera = item.carre;
      this.idCarrera = item.idcar;
      this.idPlanestudio = item.idplan;
      this.listarPlanEconomico();
      this.carreraModal = false;


    },
    seleccionarGestion(item) {
      this.gestion = item.nom;
      this.idGestion = item.id_gestion;
      this.ordGestion = item.ordenado;
      this.tipoGestion = item.tp;
      this.gestionModal = false;
      this.listarKardex(this.unicodigo, this.idCarrera);
      this.listarCantidadMateriasPreinsEstu();

      


    },
    seleccionarTurno(item) {
      this.turno = item.turno;
      this.idTurno = item.idturno;
      this.turnoModal = false;

      this.listarGruposPreInscripcion(this.idPlanestudio, this.id_sede, this.idGestion, this.idTurno, this.idTipoModalidad, this.unicodigo);
      //this.listarOfertaMaterias(this.unicodigo, this.idPlanestudio, this.idGestion);

      this.listarHorario(this.unicodigo, this.idGestion, this.idPlanestudio);
      this.listarFranjaHoraria(this.unicodigo);
      this.listarOfertaMaterias(this.unicodigo, this.idPlanestudio, this.idGestion);

      //this.listarGruposPreInscripcion(this.idPlanestudio, this.id_sede, this.idGestion, this.idTurno, this.idTipoModalidad, this.unicodigo);
      this.listarDeudaest(this.unicodigo, this.idPlanestudio, this.id_sede, this.idGestion);
      this.listarvigeciabacest();
      //this.listarOfertaMateriasMinNivel();    
      //this.verificarMinNivel()

    },
    verificarMinNivel() {
      if (!this.datosGruposPreInscripcion || this.datosGruposPreInscripcion.length === 0) {
        //console.log("El arreglo está vacío o es null");
        this.listarOfertaMateriasMinNivel();

      } else {
        //console.log("El arreglo tiene datos");
        this.listarMinNivelGruposPreInscritos();

      }

    },
    async listarDeudaest(unicodigo, idPlanestudio, id_sede) {
      let me = this;
      await axios
        .get("/pagos/listardeudaesttodas/" + this.unicodigo + "," + this.idPlanestudio + "," + this.id_sede + "," + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosDeuda = [];
            me.banddeuda = "NOTIENEDEUDA";
            if(me.bandbac === "NOTIENEBAC"){
            me.snackbarOK = true;
            me.mensajeSnackbar = "UNA VEZ SELECCIONADO UN GRUPO SOLO PODRA HACER LA TOMA DE MATERIAS DE ESE GRUPO";
            }
            
            //me.listarDocumento(me.unicodigo);

          } else {

            me.datosDeuda = response.data.resultado;
            me.banddeuda = "TIENEDEUDA";

          }
        })
        .catch(function (error) {

        });
    },
    showBuscarEstudiante() {
      //this.limpiar();
      this.elModal = true;

    },
    showHorario() {
      //this.limpiar();

      this.horarioModal = true;
      //this.listarCarrera(this.unicodigo);
    },
    closeHorario() {
      this.horarioModal = false;
    },
    showDocumento() {

      //this.listarDocumento(this.unicodigo);
      this.documentosModal = true;

    },
    closeDocumento() {
      this.documentosModal = false;
    },
    showCarrera() {
      // this.limpiar();
      this.banddeuda = "";
      this.idGestion = "";
      this.gestion = "";
      this.turno = "";
      this.idTurno = "";
      this.grupoSeleccionado = "";
      this.datosOfertaMaterias = [];
      this.datosMinNivelGruposPreInscritos = [];
      this.datosvigenciaBac=[];
      this.bandbac="";



      this.carreraModal = true;
      this.listarCarrera(this.unicodigo);
    },
    closeCarrera() {
      this.carreraModal = false;
    },
    showGestion() {
      //this.limpiar();
      this.gestionModal = true;
      this.listarGestion();
    },
    closeGestion() {
      this.gestionModal = false;
    },
    showTurno() {
      //this.limpiar();
      this.turnoModal = true;
      this.listarTurno();
    },
    closeTurno() {
      this.turnoModal = false;
    },


    showDetalleInscripcion(item) {

      this.detalleModal = true;
      this.idMateria = item.idmat;
      if (this.datosGruposPreInscripcion.length === 0) {
        this.listarGruposInscripcion(this.idMateria, this.idTurno, this.idGestion);

      } else {
        this.listarGruposInscripcionSelect();

      }

      //this.listarGruposInscripcion(this.idMateria, this.idTurno, this.idGestion);
    },
    closeDetalleInscripcion() {
      this.detalleModal = false;
    },
    showGruposPractica() {

      this.gruposPracticosModal = true;
      //this.idMateria = item.idmat;   
      this.listarGruposInscripcionPractica(this.idMateria, this.idTurno, this.idGestion);
      //this.tienePractico = 'FALSE';

    },
    closeGruposPractica() {
      this.gruposPracticosModal = false;
    },


    limpiar() {
      //this.id_docente="";
      //this.tipodocente="";
      this.carrera = "";
      this.idCarrera = "";
      this.gestion = "";
      this.idGestion = "",
        this.turno = "";
      this.idTurno = "";





    },

    addMateriaInscripcion() {
      this.añadirMateriaInscripcion(
        this.unicodigo,
        this.id_sede,
        this.idUsuario,
        this.idTurno,
        this.idCarrera,
        this.idGestion,
        this.idPlanEconomico,

      );
      this.botonAct = 0;
    },
    async añadirMateriaInscripcion(
      unicodigo,
      id_sede,
      idUsuario,
      idTurno,
      idCarrera,
      idGestion,
      idPlanEconomico,

    ) {
      let me = this;

      //let me=this;
      await axios
        .post(
          "/estudiante/addMateriaInscripcion/" +
          this.unicodigo +
          "," +
          this.id_sede +
          "," +
          this.idUsuario +
          "," +
          this.idTurno +
          "," +
          this.idCarrera +
          "," +
          this.idGestion +
          "," +
          this.idPlanEconomico


        )
        .then(function (response) {

          me.snackbarOK = true;
          me.mensajeSnackbar = response.data.message;

          me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);

          me.listarFranjaHoraria(me.unicodigo);

          //me.cantidadActualMaterias++;
        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });
    },
    async establecerMateriaRecursada(unicodigo, idMateria) {

      let me = this;
      await axios.post("/estudiante/establecermateriarecur/" + this.unicodigo + "," + this.idMateria)
        .then(function (response) {


        })
        .catch(function (error) {

        });
    },
    verificarPreinscipcionNota() {

      this.verificarRecursada(this.unicodigo, this.idMateria, this.idGestion);
      //this.verificarpre(this.idGrupoDocente, this.unicodigo, this.idMateria);

    },
    async verificarpre(idGrupoDocente, unicodigo, idMateria) {

      let me = this;
      await axios.get("/estudiante/verificarpreinscrito/" + this.idGrupoDocente + "," + this.unicodigo + "," + this.idMateria)
        .then(function (response) {

          if (response.data.resultado == null) {
            //me.idGrupoAux = me.idGrupoDocente;
            me.verificarExsiteMatPractica();
            // me.addMateriaInscripcionNota();


          } else {
            //me.snackbarError = true;
            //me.mensajeSnackbar = response.data.message;
          }
        })
        .catch(function (error) {

        });
    },
    async verificarRecursada(unicodigo, idMateria, idGestion) {
      let me = this;
      await axios
        .get(
          "/estudiante/verificarRecursada/" +
          this.unicodigo +
          "," +
          this.idMateria +
          "," +
          this.idGestion +
          "," +
          this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosRecursado = [];
            me.verificarBanderaRecursada();

          } else {
            me.datosRecursado = response.data.resultado;
            me.verificarBanderaRecursada();
            //me.banderaRecursado = 1;
          }
        })
        .catch(function (error) { });
      //  console.log("datosRecursado "+me.datosRecursado);
      //me.verificarBanderaRecursada();
    },
    verificarBanderaRecursada() {

      if (this.datosRecursado != null && this.datosRecursado.length > 0) {
        this.banderaRecursado = 1;

      } else {
        this.banderaRecursado = 0;
      }
      this.verificarpre(this.idGrupoDocente, this.unicodigo, this.idMateria);
    },
    async listarCantActualInscr(idGrupoDocente) {
      let me = this;
      await axios
        .get("/estudiante/verificarEspacio/" + this.idGrupoDocente)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCantidadEspacio = [];
          } else {
            me.datosCantidadEspacio = response.data.resultado;

            me.espacioVerificado();
          }
        })
        .catch(function (error) {
        });
    },
    /* verificarExisteMateriaPractica() {
   
       this.verificarExsiteMatPractica(this.idPlanestudio, this.idGestion, this.idMateria);
   
     },*/
    limpiarrecursada() {
      this.recursada = "N";
      this.recursadapr = "N";
    },
    async verificarExsiteMatPractica(idPlanestudio, idGestion, idMateria) {
      let me = this;
      await axios
        .get("/estudiante/verificarExisteMateriaPractica/" + this.idPlanestudio + "," + this.idGestion + "," + this.idMateria +
          "," +
          this.id_sede)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.tienePractico = 'FALSE';
            me.addMateriaInscripcionNota();
          } else {
            me.tienePractico = 'TRUE';
            //me.listarGruposInscripcionPractica();
            me.showGruposPractica();
          }
        })
        .catch(function (error) {

        });
    },
    verificarHorario() {
      this.verificarhorario(this.idFranjaHoraria, this.unicodigo, this.idDia);
    },
    async verificarhorario(idFranjaHoraria, unicodigo, idDia) {

      let me = this;
      await axios.get("/estudiante/verificarhorario/" + this.idFranjaHoraria + "," + this.unicodigo + "," + this.idDia)
        .then(function (response) {

          if (response.data.resultado == null) {




          } else {
            me.snackbarError = true;
            me.mensajeSnackbar = response.data.message;

          }

        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });

    },
    addMateriaInscripcionNota() {

      if (this.banderaRecursado == 1) {
        this.recursada = "RECURSADA";
        this.recursadapr = "RECURSADA";

        //console.log("re"+this.recursada);
        // console.log("rep"+this.recursadapr);

      }
      // console.log("baderaRec es 0");
      this.añadirMateriaInscripcionNota(

      );
      //this.botonAct = 0;
    },
    async añadirMateriaInscripcionNota() {
      let me = this;


      await axios
        .post(
          "/estudiante/addMateriaInscripcionNota/" +
          this.id_sede +
          "," +
          this.idTurno +
          "," +
          this.idGestion +
          "," +
          this.unicodigo +
          "," +
          this.idPlanestudio +
          "," +
          this.idMateria +
          "," +
          this.paraleloTeorico +
          "," +
          this.idGrupoDocente +
          "," +
          this.tipoInscripcion +
          "," +
          this.recursada +
          "," +
          this.idPlanEconomico +
          "," +
          this.usuario

        )
        .then(function (response) {
          me.mensajeSnackbar = response.data.message;
          me.snackbarOK = true;
          //me.listarregistrado();
          me.listarOfertaMaterias(me.unicodigo, me.idPlanestudio, me.idGestion);
          me.listarGruposPreInscripcion();
          me.limpiarrecursada();
          me.listarCantidadMateriasPreinsEstu();
          me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);

          //me.listarKardex();
          //me.registrarEstudianteCarEco();
          // me.verificarExsiteMatPractica()

          // me.cantidadActualMaterias++;
        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });
    },
    addMateriaInscripcionNota1() {
      this.añadirMateriaInscripcionNota1(

      );
      //this.botonAct = 0;
    },
    async añadirMateriaInscripcionNota1(

    ) {
      let me = this;

      //let me=this;
      await axios
        .post(
          "/estudiante/addMateriaInscripcionNota/" +
          this.id_sede +
          "," +
          this.idTurno +
          "," +
          this.idGestion +
          "," +
          this.unicodigo +
          "," +
          this.idPlanestudio +
          "," +
          this.idMateria +
          "," +
          this.paralelo +
          "," +
          this.idGrupoDocentePrac +
          "," +
          this.tipoInscripcion +
          "," +
          this.recursadapr +
          "," +
          this.idPlanEconomico +
          "," +
          this.usuario
        )
        .then(function (response) {
          me.mensajeSnackbar = response.data.message;
          me.snackbarOK = true;
          //  me.listarregistrado();
          me.listarOfertaMaterias(me.unicodigo, me.idPlanestudio, me.idGestion);

          //me.listarGruposPreInscripcion(me.idPlanestudio, me.id_sede, me.idGestion, me.idTurno, me.idTipoModalidad, me.unicodigo);
          // me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);

          // me.listarKardex();

          me.addMateriaInscripcionNota();

          // me.verificarExsiteMatPractica()

          // me.cantidadActualMaterias++;
        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });
    },
    addMateriaInscripcionNota1() {


      this.añadirMateriaInscripcionNota1(

        this.id_sede,
        this.idTurno,
        this.idGestion,
        this.unicodigo,
        this.idPlanestudio,
        this.idMateria,
        this.paraleloPrac,
        this.idGrupoDocente,
        this.tipoInscripcion,
        this.recursada
      );
      //this.botonAct = 0;
    },

    verificarPreinscipcionNotaPractica() {
      this.verificarprePractica(this.unicodigo, this.idGestion, this.idMateria);

    },
    async verificarprePractica(unicodigo, idGestion, idMateria) {

      let me = this;
      await axios.get("/estudiante/verificarpreinscritopractico/" + this.unicodigo + "," + this.idGestion + "," + this.idMateria)
        .then(function (response) {

          if (response.data.resultado == null) {

            me.addMateriaInscripcionNota1();
          } else {
            //me.snackbarError = true;
            //me.mensajeSnackbar = response.data.message;

          }

        })
        .catch(function (error) {
          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;
        });

    },
    seleccionarQuitarMateria(item) {
      this.idNota = item.nt;
      this.idMateria = item.idma;
      this.tipoGrupo = item.tpgru;
      this.idNivel = item.idnv;
      this.encontrarNivelAltoGrupoPreinscritos();


    },
    verificarQuitarMateria() {
      if (this.tipoGrupo == 'PRACTICO') {
        this.quitarMateriaPractica(this.idNota, this.idMateria, this.unicodigo, this, this.idGestion);
      } else {
        this.quitarMateriaTeorico(this.idNota, this.idMateria, this.unicodigo, this.idGestion);
      }
    },

    async quitarMateriaPractica(idNota) {
      let me = this;
      await axios
        .post("/estudiante/quitarMateriaOfertaTeorico/" + this.idNota + "," + this.idMateria + "," + this.unicodigo + "," + this.idGestion)
        .then(function (response) {
          me.snackbarOK = true;
          me.mensajeSnackbar = response.data.message;
          me.listarGruposPreInscripcion(me.idPlanestudio, me.id_sede, me.idGestion, me.idTurno, me.idTipoModalidad, me.unicodigo);
          me.listarOfertaMaterias(me.unicodigo, me.idPlanestudio, me.idGestion);

          me.listarCantidadMateriasPreinsEstu();
          // me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);
          //   me.listarFranjaHoraria(me.unicodigo);
          // me.listarKardex();
          // me.maxMateriasPreinscritas--;

        })
        .catch(function (error) {

          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;

        });
    }, async quitarMateriaTeorico(idNota, idMateria, unicodigo) {
      let me = this;
      await axios
        .post("/estudiante/quitarMateriaOfertaTeorico/" + this.idNota + "," + this.idMateria + "," + this.unicodigo + "," + this.idGestion)
        .then(function (response) {
          me.snackbarOK = true;
          me.mensajeSnackbar = response.data.message;
          me.listarGruposPreInscripcion(me.idPlanestudio, me.id_sede, me.idGestion, me.idTurno, me.idTipoModalidad, me.unicodigo);
          me.listarOfertaMaterias(me.unicodigo, me.idPlanestudio, me.idGestion);

          me.listarCantidadMateriasPreinsEstu();
          // me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);
          // me.listarKardex();
          // me.listarFranjaHoraria(me.unicodigo);
          // me.maxMateriasPreinscritas--;

        })
        .catch(function (error) {

          me.snackbarError = true;
          me.mensajeSnackbar = response.data.message;

        });
    },
    verificarInscripcion() {
      this.verificariscrip(this.idGestion, this.unicodigo);

    },
    async verificariscrip(idGestion, unicodigo) {


      let me = this;
      await axios.get("/estudiante/verificarinscripcion/" + this.idGestion + "," + this.unicodigo)
        .then(function (response) {

          if (response.data.resultado == null) {

            me.addMateriaInscripcion();

          } else {
            me.snackbarError = true;
            me.mensajeSnackbar = response.data.message;

          }

        })
        .catch(function (error) {
          //me.snackbarError = true;
          //me.mensajeSnackbar = response.data.message;
        });

    },


    deleteItem(item) {
      this.editedIndex = item.nitf;
      this.editedItem = item.nitf;
      // this.dialogDelete = true
    },


    close() {
      this.elModal = false;
    },
    showCompromiso() {
      this.compromisoModal = true;

    },
    closeCompromiso() {
      this.compromisoModal = false;
    },
    showKardex() {
      this.kardexModal = true;

    },
    closeKardex() {
      this.kardexModal = false;
    },
    showRegcompromiso(item) {
      this.iddocseg1 = item.iddocseg
      this.documento1 = item.documento
      this.regcompromisoModal = true;
    },
    closeRegcompromiso() {
      this.regcompromisoModal = false;
    },
    realizarcompromiso() {
      this.regcompromisoModal = false;
      this.registrarcompromisodoc(this.iddocseg1, this.fplazo);


      // this.registrarcobrodetalle(this.id_docente)
    },




  },
};
</script>